import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('utenti');
export const actions = helper.createActions('utenti', actionTypes);
